import { COMPONENT_VALUE_TYPES as types, PERCENTAGES,
  TWO_COLUMN_TEXT_LAYOUTS } from 'shared/constants';

const propsSchema = [
  {
    key: 'background_video_frames',
    label: 'List of images of the background video',
    type: types.OBJECT,
    children: [
      {
        key: 'base_url',
        label: 'Base image URL',
        type: types.TEXT,
      },
      {
        key: 'starting_frame_number',
        label: 'Images will be shown starting from this number (Format: 1, 2, 3, ..., 10, 11, ..., 220, 221)',
        type: types.TEXT,
      },
      {
        key: 'image_type',
        label: 'Image Type (jpg, png)',
        type: types.TEXT,
      },
      {
        key: 'total_frames',
        label: 'Total amount of images uploaded',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'background_video',
    label: 'Background Video',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Video Link',
        type: types.TEXT,
      },
      {
        key: 'cover',
        label: 'Video Cover',
        type: types.TEXT,
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES,
      },
    ],
  },
  {
    key: 'text',
    label: 'Text',
    type: types.ARRAY,
    children: [
      {
        key: 'large_title',
        label: 'Large Title',
        type: types.TEXT,
      },
      {
        key: 'small_title',
        label: 'Small Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT,
      },
      {
        key: 'layout',
        label: 'Layout',
        type: types.ENUM,
        options: TWO_COLUMN_TEXT_LAYOUTS,
      },
    ],
  },
];

const defaultProps = {
  background_video_frames: {
    base_url: 'https://genesis-cdn.ff.com/assets/pages/our-approach/battery/',
    starting_frame_number: '1',
    image_type: 'jpg',
    total_frames: '59',
  },
  background_video: {
    url: 'https://genesis-cdn.ff.com/our_approach/03_vpa/FF_WEB_BATTERY_B_3x2_02E.mp4',
    cover: '',
    dark_overlay: '0',
  },
  text: [
    {
      large_title: 'Engineering',
      small_title: '',
      subtitle: 'Variable Platform Architecture',
      description:
        'Every FF vehicle is built upon the VPA, our universal, dynamic powertrain. This unique architecture is both exceptionally strong for greater stability and highly adaptable to accommodate a wide range of vehicles.',
      layout: 'RIGHT',
    },
    {
      large_title: '',
      small_title: 'FF ENGINEERING',
      subtitle: 'Battery Technology',
      description:
        'Our engineers designed a technology that achieves the world’s highest energy density for a production automotive battery. This bold leap in battery technology provides a tremendous increase in driving range and peak power duration.',
      layout: 'LEFT',
    },
  ],
};

export default {
  title: 'Scroll Video',
  id: 'ScrollVideo',
  propsSchema,
  defaultProps
};

